import { TriangleIcon, VolumeBarIcon } from "@assets";
import { LBtn, LFlex, LModal, LSubTitle, LTitle } from "@components";
import { useEffect } from "react";
import { translate } from "react-i18nify";

export const MicCheckOpenModal = ({
    onClose,
    startSpeechToText,
    recordingVolume
}: MicCheckOpenModalProps): JSX.Element => {
    const handleOnClose = (): void => {
        onClose?.();
    };

    const handleOnConfirm = (): void => {
        onClose?.();
    };

    useEffect(() => {
        setTimeout(() => {
            void startSpeechToText();
        }, 500);
    }, []);

    return (
        <LModal
            keepActionsVisibleOnMobileLandscape
            onClose={handleOnClose}
            onConfirm={handleOnConfirm}
            footer={
                <LFlex alignCenter justifyCenter className="mb-5">
                    <LBtn onClick={handleOnConfirm} isBold>
                        {translate("assessments.deviceCheck.microphone.done")}
                    </LBtn>
                </LFlex>
            }
            width={"m"}
            fullHeight={false}
        >
            <LFlex alignCenter justifyCenter className="assessment-mic-check p-4">
                <LTitle color="has-text-dark-blue" size="4">
                    {translate("assessments.deviceCheck.microphone.sayShape")}
                </LTitle>
                <LFlex alignCenter justifyCenter className="assessment-mic-check-feedback mt-6">
                    <TriangleIcon />
                    <div className="mt-6">
                        <VolumeBarIcon volume={recordingVolume ?? 0} />
                    </div>
                </LFlex>
                <LSubTitle color="has-text-dark-blue" size="5" className="mt-6">
                    {translate("assessments.deviceCheck.microphone.clickDone")}
                </LSubTitle>
            </LFlex>
        </LModal>
    );
};

interface MicCheckOpenModalProps {
    onClose?: () => void;
    startSpeechToText: () => void;
    recordingVolume?: number;
}
